<div class="modal">
  <div class="modal-content">
    <div class="headerModal">
      <h3>{{'stats.keyFactors.settings.title'|translate}}</h3>
      <span class="close pointer" style="padding-left: 2em;" (click)="doClose()">
        <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i>
      </span>
    </div>
    <div>
      <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let kf of keyfactors" class="listElem" cdkDrag>
          <mat-slide-toggle [(ngModel)]="kf.visible" hideIcon>{{kfKeys[kf.name]|translate}}</mat-slide-toggle>
          <div style="flex-grow: 1;"></div>
          <div class="graph-handle" cdkDragHandle>
            <img src="assets/stats/handle.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="center">
        <button (click)="doSave()">{{'stats.keyFactors.settings.save'|translate}}</button>
      </div>
    </div>
  </div>
</div>
